var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreloader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9285714285714286s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(25.714285714285715 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8571428571428571s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(51.42857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.7857142857142857s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(77.14285714285714 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.7142857142857143s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(102.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6428571428571429s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(128.57142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5714285714285714s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(154.28571428571428 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.42857142857142855s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(205.71428571428572 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.35714285714285715s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(231.42857142857142 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.2857142857142857s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(257.14285714285717 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.21428571428571427s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(282.85714285714283 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.14285714285714285s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(308.57142857142856 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.07142857142857142s",
    repeatCount: "indefinite"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(334.2857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    rx: 2.5,
    ry: 4.68,
    width: 5,
    height: 12,
    fill: "#7199fe"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreloader);
export default __webpack_public_path__ + "static/media/preloader.5634844f9ab5e2aca4d31c3090a0574c.svg";
export { ForwardRef as ReactComponent };